<div class="row">
    <div [ngClass]="{col: 'horizontal'}"><wd-text *ngIf="model && model!.neu" [name]="name + 'Neu'" [(model)]="model!.neu"></wd-text></div>
    <div [ngClass]="{col: 'horizontal'}"><wd-text *ngIf="model && model!.alt" [name]="name + 'Alt'" [model]="(model!.neu ? 'alt: ' : '') + model!.alt"></wd-text></div>
</div>
